<template>
    <div>
        <h3 class="mt-3">{{index + 1}} - {{question.translation.name}}</h3>
        <span
            v-if="question.translation.description"
            class="mb-3 d-block"
            v-html="question.translation.description"
        ></span>
        <fieldset :id="`question_id-${question.id}`" :class="{ verifyValidate: verifyValidate && error.has('option')}" class="p-1">
            <label
                v-for="option in question.options"
                :key="option.id"
                class="btn-group d-flex my-3 justify-content-between align-items-center"
                :id="`question_id-${question.id}`"
                :style="[
                    visualFeedback(option),
                    hoverAnimation(color.primary, option.id),
                    (model === option.id) && !exercise.show_answer ? onSelected(color.primary) : ''
                ]"
                @mouseover="!isFinished ? onMouseOver(option.id): false"
                @mouseleave="onMouseLeave()"
            >
                <input
                    data-vv-name="option"
                    v-validate="'required'"
                    type="radio"
                    class="mr-3 custom-control-input"
                    :id="option.id"
                    :name="`option-${option.name}`"
                    :value="option.id"
                    v-model="model"
                    :disabled="isDisabled(option.id)"
                    @change="submitOption"
                />

                <div>{{option.name}}</div>

                <span
                    v-if="model === option.id"
                    class="material-icons"
                    :style="`color:${color.primary}`"
                >radio_button_checked</span>
            </label>
            <span v-if="error.has('option') && verifyValidate" class="invalid-feedback" style="display: block;">
                {{ $t('exercise.validate.check_error') }}
            </span>
        </fieldset>
    </div>
</template>

<script>
import hoverEffect from '../../mixins/hoverEffect'

export default {
    name: 'ExerciseSingleAnswer',
    mixins: [hoverEffect],
    data() {
        return {
            answers: [],
            model: '',
            rightQuestion: {
                'background-color':'#f5f5f5',
                'box-shadow': '0 0 0 3px #336e2f !important'
            },
            WrongQuestion: {
                'background-color':'#f5f5f5',
                'box-shadow': '0 0 0 3px #851818 !important'
            },
            error: this.$validator.errors
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        isFinished: {
            type: Boolean,
        },
        verifyValidate: {
            type: Boolean
        }

    },
    computed: {
        exercise() {
            return this.$store.getters.LOADED_EXERCISE
        },
        color() {
            return this.$store.getters.COLOR
        }
    },
    watch: {
        question(newVal) {
            this.model = newVal.answer
        }
    },
    methods: {
        isDisabled(id) {
            return this.isFinished
        },

        visualFeedback(option) {
            let showAnswer = this.exercise.show_answer

            if(showAnswer && option.correct){
                return this.rightQuestion;
            }else if(showAnswer && !option.correct && option.id === this.model){
                return this.WrongQuestion;
            }
        },
        async submitOption() {
            const response = await this.$store.dispatch('SUBMIT_OPTION', {
                exerciseId: this.exercise.id,
                questionId: this.question.id,
                answer: this.model
            });

            if (!response) {
                this.model = '';
                this.$notify({
                    type: 'danger',
                    message: this.$t('content.exercise.error.no_connection'),
                });
            }
        }
    },
    mounted() {
        let answer = this.question.answer
        if(answer) return this.model = answer
    },
}
</script>
<style>
.verifyValidate{
    border-radius: 5px;
    border: 2px solid red;
}
</style>
